import { createFileRoute } from '@tanstack/react-router';
import { PosMicrosConfigurationDetail } from '@mews-commander/modules/src/modules/integrations';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => <PosMicrosConfigurationDetail integrationId={Route.useParams().id} />;

export const Route = createFileRoute(
    '/_authenticated/$currentEnterpriseId/ConnectorIntegration/PosMicros/Configuration/$id'
)({
    component: Component,
    staticData: {
        owner: MewsTeam.Connectivity,
        type: RouteType.Frontend,
    },
});
